import type { CheckboxGroupType } from '~/presentation/reports/ui/type';

import { useMemo } from 'react';

interface UseSearchItemsProps {
  queryValue: string;
  optionsGroup: CheckboxGroupType;
}
export const useSearchItems = ({ queryValue, optionsGroup }: UseSearchItemsProps) => {
  const listItems = useMemo(() => {
    if (!queryValue) return optionsGroup;

    return optionsGroup.map((item) => {
      return {
        ...item,
        options: item.options.filter((option) => {
          return option.label.toLowerCase().includes(queryValue.toLowerCase());
        }),
      };
    });
  }, [queryValue, optionsGroup]);

  const hasItems = listItems.some((item) => item.options.length > 0);

  return { listItems, hasItems };
};
